/**
 * @description renders an actions table cell that includes an actions container that is only visible when the user hovers over the row.
 *  Note that both the TableActionsCell and the rowStyles have to be applied to the consuming table.
 */

import React from 'react';
import { PropTypes } from 'prop-types';
import TableCell from '@mui/material/TableCell';
import Box from '@mui/material/Box';

const styles = {
  cell: {
    width: '1%'
  },
  actionsContainer: {
    marginRight: 1,
    whiteSpace: 'nowrap',
    wordBreak: 'normal'
  }
};

// Defines the row styles that need to be applied to the TableRow component in order to show/hide the actions container
export const rowStyles = {
  '& .actionsContainer': {
    visibility: 'hidden'
  },
  '&:hover .actionsContainer': {
    visibility: 'visible'
  }
}

// This is the table actions cell that renders the appropriate cell and container
export const TableActionsCell = ({ children }) => (
  <TableCell padding='none' sx={styles.cell}>
    <Box className='actionsContainer' sx={styles.actionsContainer}>
      {children}
    </Box>
  </TableCell>
);

TableActionsCell.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)])
};

TableActionsCell.defaultProps = {
  children: null
};
